export default "__VITE_PUBLIC_ASSET__f0f81b34__"